module.exports = __webpack_public_path__ + "img/2.ebfc5348.jpg";